"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NotifyForSelector = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const frontend_infra_localisation_1 = require("@forto-dev/frontend-infra-localisation");
const silhouette_core_1 = require("@freighthub/silhouette-core");
const translations_1 = require("../types/translations");
const NotifyForSelector = ({ onChange, value }) => {
    const { translate } = (0, frontend_infra_localisation_1.useI18n)();
    const handleOptionSelect = (event) => {
        onChange(event.target.value);
    };
    return ((0, jsx_runtime_1.jsxs)(silhouette_core_1.RadioGroup, { onChange: handleOptionSelect, value: value, children: [(0, jsx_runtime_1.jsx)(silhouette_core_1.FormControlLabel, { value: "all", control: (0, jsx_runtime_1.jsx)(silhouette_core_1.Radio, {}), label: translate(translations_1.notifyForTranslations.optionAll) }), (0, jsx_runtime_1.jsx)(silhouette_core_1.FormControlLabel, { value: "subscribedOnly", control: (0, jsx_runtime_1.jsx)(silhouette_core_1.Radio, {}), label: translate(translations_1.notifyForTranslations.optionSubscribedOnly) })] }));
};
exports.NotifyForSelector = NotifyForSelector;
//# sourceMappingURL=NotifyForSelector.js.map